import { GENERIC_ERROR_MESSAGE } from "../constants";

interface MessageType {
  error: { msg: string | MessageType }[];
}

export const getErrorMessage = (message: string | MessageType): string => {
  if (typeof message === "object") {
    return getErrorMessage(message.error[0].msg);
  }

  if (typeof message === "string") {
    return message;
  }

  return GENERIC_ERROR_MESSAGE;
};
